export default "__VITE_ASSET__BzisVbGe__"